<template>
  <page-view :title="true">
    <a-card>
      <a-form-model
        ref="ruleForm"
        :rules="formRules"
        :model="formData"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-row :gutter="24">
          <a-col :sm="24" :md="24" :xl="24"
            ><a-descriptions title="基本信息"></a-descriptions
          ></a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="名称" prop="merchantName"
              ><a-input v-model="formData.merchantName" placeholder="请输入名称"
            /></a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="省份" prop="province">
              <a-select
                placeholder="请选择省份"
                v-model="formData.province"
                allow-clear
                @change="handleProvinceChange"
              >
                <a-select-option
                  v-for="item in provinceList"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.descript }}({{ item.code }})</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="城市" prop="city">
              <a-select
                placeholder="请选择城市"
                v-model="formData.city"
                allowClear
              >
                <a-select-option
                  v-for="item in tmpCityList"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.descript }}({{ item.code }})</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item
              label="地址"
              prop="address"
              :labelCol="{ span: 3 }"
              :wrapperCol="{ span: 21 }"
            >
              <a-input
                :rows="1"
                type="textarea"
                v-model="formData.address"
                placeholder="请输入地址"
              />
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item
              label="介绍"
              prop="intro"
              :labelCol="{ span: 3 }"
              :wrapperCol="{ span: 21 }"
            >
              <a-input
                :rows="4"
                type="textarea"
                v-model="formData.intro"
                placeholder="请输入介绍"
              />
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="24" :xl="24"
            ><a-descriptions
              title="认证信息(公司)"
              v-if="merchantInfo.merchantType == 1"
            ></a-descriptions
          ></a-col>
          <div v-if="merchantInfo.merchantType == 1">
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="企业名称" prop="enterpriseName"
                ><a-input
                  v-model="formData.enterpriseName"
                  placeholder="请输入企业名称"
              /></a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="社会信用代码" prop="licenseCode">
                <a-input
                  v-model="formData.licenseCode"
                  placeholder="请输入社会信用代码"
                />
              </a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="经办人姓名" prop="legalPerson"
                ><a-input
                  v-model="formData.legalPerson"
                  placeholder="请输入经办人姓名"
              /></a-form-model-item>
            </a-col>

            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="经办人证件号" prop="legalPersonNo">
                <a-input
                  v-model="formData.legalPersonNo"
                  placeholder="请输入经办人证件号"
                />
              </a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="联系方式" prop="contactMobile"
                ><a-input
                  v-model="formData.contactMobile"
                  placeholder="请输入联系方式"
              /></a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="联系邮箱" prop="contactEmail"
                ><a-input
                  v-model="formData.contactEmail"
                  placeholder="请输入联系邮箱"
              /></a-form-model-item>
            </a-col>

            <a-col :sm="24" :md="24" :xl="24">
              <a-form-model-item
                label="备注"
                prop="enterpriseRemark"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 21 }"
              >
                <a-input
                  :rows="4"
                  type="textarea"
                  v-model="formData.enterpriseRemark"
                  placeholder="请输入备注"
                />
              </a-form-model-item>
            </a-col>
          </div>
          <a-col :sm="24" :md="24" :xl="24"
            ><a-descriptions
              title="认证信息(个人)"
              v-if="merchantInfo.merchantType == 2"
            ></a-descriptions
          ></a-col>
          <div v-if="merchantInfo.merchantType == 2">
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="真实姓名" prop="realName"
                ><a-input
                  v-model="formData.realName"
                  placeholder="请输入真实姓名"
              /></a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="身份证号" prop="idCardNo"
                ><a-input
                  v-model="formData.idCardNo"
                  placeholder="请输入身份证号"
              /></a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="手机号" prop="mobile"
                ><a-input v-model="formData.mobile" placeholder="请输入手机号"
              /></a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8">
              <a-form-model-item label="银行卡号"
                ><a-input v-model="formData.bankNo" placeholder="请输入银行卡号"
              /></a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="24" :xl="24">
              <a-form-model-item
                label="备注"
                prop="personalRemark"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 21 }"
              >
                <a-input
                  :rows="4"
                  type="textarea"
                  v-model="formData.personalRemark"
                  placeholder="请输入备注"
                />
              </a-form-model-item>
            </a-col>
          </div>
          <a-col :sm="24" :md="24" :xl="24"
            ><a-descriptions title="收款账户信息"></a-descriptions
          ></a-col>
          <a-col :sm="24" :md="24" :xl="24">
            <div class="account-box">
              <div style="text-align: right;margin: 10px 0;">
                <a @click="() => (visible = true)">添加收款账户</a>
              </div>
            </div>
            <div class="cell" v-for="(item, index) in accountList" :key="index">
              <div class="accout">
                账户类型：{{ item.accountType }}
                <a-tag
                  class="render-tag"
                  color="#108ee9"
                  v-if="item.isDefault == 'T'"
                  >默认账户</a-tag
                >
              </div>
              <div style="width: 25%;">账户名称：{{ item.accountName }}</div>
              <div style="width: 25%;">账户号：{{ item.accountNo }}</div>
              <div class="opt">
                <a @click="action(item, index, 'modify')">编辑</a>
                <a @click="action(item, index, 'del')">删除</a>
                <a @click="action(item, index, 'default')">设置默认账户</a>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="operation">
        <a-button @click="back">返回</a-button>
        <a-button type="primary" :loading="loading" @click="save"
          >保存</a-button
        >
      </div>
    </a-card>

    <a-modal
      v-model="visible"
      title="添加收款账户"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form-model
        ref="accountForm"
        :rules="formAccountRules"
        :model="formAccount"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="账户类型" prop="accountType">
          <a-select
            v-model="formAccount.accountType"
            placeholder="请选择账户类型"
          >
            <a-select-option
              v-for="item in accountTypeList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}({{ item.value }})</a-select-option
            >
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="账户名称" prop="accountName"
          ><a-input
            v-model="formAccount.accountName"
            placeholder="请输入账户名称"
        /></a-form-model-item>

        <a-form-model-item label="账户号" prop="accountNo"
          ><a-input v-model="formAccount.accountNo" placeholder="请输入账户号"
        /></a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-view>
</template>

<script>
import { PageView } from "@/layouts";
export default {
  components: {
    PageView
  },
  name: "ModifyMerchantInfo",
  data() {
    return {
      queryParam: null,
      merchantNo: "", // 商户编号
      enterprise: {}, //企业认证信息
      personal: {}, //个人认证信息
      merchantInfo: {}, //商户基本信息
      logoList: [],
      accountList: [], //商户账户信息
      labelCol: { span: 9 },
      wrapperCol: { span: 15 },
      provinceList: [],
      cityList: [],
      tmpCityList: [],
      accountTypeList: [
        { name: "银行卡", value: "BANK" },
        { name: "微信", value: "WEIXIN" },
        { name: "支付宝", value: "ALIPAY" }
      ],
      loading: false, //是否保存
      visible: false,
      formData: {
        merchantNo: "",
        merchantName: "",
        province: undefined,
        city: undefined,
        address: "",
        intro: "",
        enterpriseName: "", //企业名称
        licenseCode: "", //社会信用代码
        legalPerson: "", //经办人姓名
        legalPersonNo: "", //经办人证件号
        contactMobile: "", //联系方式
        contactEmail: "", //联系邮箱
        enterpriseRemark: "", //备注
        realName: "", //=======个人用户 真是姓名
        idCardNo: "", //身份证号
        bankNo: "", //银行卡号
        mobile: "", //手机号
        personalRemark: "" //备注
      },
      formAccount: {
        merchantNo: "",
        accountType: undefined, //账户类型
        accountName: "", //账户名称
        accountNo: "", //账户号
        isDefault: "F"
      },
      deleteAccountList: [],
      accountIndex: -1,
      formRules: {
        merchantName: [{ required: true, message: "请输入名称" }],
        province: [{ required: true, message: "请选择省份" }],
        city: [{ required: true, message: "请选择城市" }],
        address: [{ required: true, message: "请输入地址" }],
        intro: [{ required: true, message: "请输入介绍" }],
        enterpriseName: [{ required: true, message: "请输入企业名称" }],
        licenseCode: [{ required: true, message: "请输入社会信用代码" }],
        legalPerson: [{ required: true, message: "请输入经办人姓名" }],
        legalPersonNo: [{ required: true, message: "请输入经办人证件号" }],
        contactMobile: [{ required: true, message: "请输入联系方式" }],
        contactEmail: [{ required: true, message: "请输入联系邮箱" }],
        enterpriseRemark: [{ required: true, message: "请输入备注" }],
        realName: [{ required: true, message: "请输入真实姓名" }],
        idCardNo: [{ required: true, message: "请输入身份证号" }],
        mobile: [{ required: true, message: "请输入手机号" }],
        personalRemark: [{ required: true, message: "请输入备注" }]
      },
      formAccountRules: {
        accountType: [{ required: true, message: "请选择账户类型" }],
        accountName: [{ required: true, message: "请输入账户名称" }],
        accountNo: [{ required: true, message: "请输入账户号" }]
      }
    };
  },
  created() {
    let query = this.$route.query;
    if (query.merchantNo) {
      this.merchantNo = query.merchantNo;
      this.getMerchantInfo();
    }
    if (query.param) {
      this.queryParam = query.param;
    }
    this.getBaseHelpCode();
  },
  methods: {
    back() {
      this.$router.push({
        name: "MerchantList",
        query: { param: this.queryParam }
      });
    },
    async getMerchantInfo() {
      this.$http.roomBksApi
        .findMerchantBaseByMerchantNo({ merchantNo: this.merchantNo })
        .then(res => {
          if (res && res.result == 0) {
            this.merchantInfo = res.resultObject.merchantInfo;
            Object.assign(this.formData, this.merchantInfo);
            if (this.merchantInfo.merchantType == 1) {
              this.enterprise = res.resultObject.enterprise;
              Object.assign(this.formData, this.enterprise);
              if (this.enterprise) {
                this.formData.enterpriseRemark = this.enterprise.remark;
              }
            } else {
              this.personal = res.resultObject.personal;
              Object.assign(this.formData, this.personal);
              if (this.personal) {
                this.formData.personalRemark = this.personal.remark;
              }
            }
            this.accountList = res.resultObject.merchantAccountList;
          }
        });
    },
    async getBaseHelpCode() {
      this.$http.systemBksApi
        .findProvinceCityDistrictCircleHelpCode({
          isProvince: "T",
          isCity: "T"
        })
        .then(res => {
          this.provinceList = res.resultObject.provinceList;
          this.cityList = res.resultObject.cityList;
        });
    },
    handleProvinceChange(value) {
      let arr = [];
      for (let city of this.cityList) {
        if (city.provinceCode == value) {
          arr.push(city);
        }
      }
      this.tmpCityList = arr;
    },
    handleOk() {
      this.$refs.accountForm.validate(valid => {
        if (valid) {
          let obj = Object.assign({}, this.formAccount);
          if (this.accountIndex == -1) {
            obj.merchantNo = this.merchantNo;
            let flag = true;
            for (let cur of this.accountList) {
              if (
                obj.accountType == cur.accountType &&
                obj.accountNo == cur.accountNo
              ) {
                flag = false;
                break;
              }
            }
            if (flag) {
              this.accountList.push(obj);
              this.cancel();
            } else {
              this.$message.info("收款账户已存在");
            }
          } else {
            this.accountList.splice(this.accountIndex, 1, obj);
            this.cancel();
          }
        }
      });
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = {};
          let base = {};
          base.merchantNo = this.formData.merchantNo;
          base.merchantType = this.merchantInfo.merchantType;
          base.merchantName = this.formData.merchantName;
          base.province = this.formData.province;
          base.city = this.formData.city;
          base.address = this.formData.address;
          base.intro = this.formData.intro;
          param.merchantInfo = base;
          if (this.merchantInfo.merchantType == 1) {
            let enterprise = {};
            enterprise.merchantNo = this.formData.merchantNo;
            enterprise.enterpriseName = this.formData.enterpriseName;
            enterprise.licenseCode = this.formData.licenseCode;
            enterprise.legalPerson = this.formData.legalPerson;
            enterprise.legalPersonNo = this.formData.legalPersonNo;
            enterprise.contactMobile = this.formData.contactMobile;
            enterprise.contactEmail = this.formData.contactEmail;
            enterprise.remark = this.formData.enterpriseRemark;
            param.enterprise = enterprise;
          } else {
            param.enterprise = null;
          }

          if (this.merchantInfo.merchantType == 2) {
            let personal = {};
            personal.merchantNo = this.formData.merchantNo;
            personal.realName = this.formData.realName;
            personal.idCardNo = this.formData.idCardNo;
            personal.bankNo = this.formData.bankNo;
            personal.mobile = this.formData.mobile;
            personal.remark = this.formData.personalRemark;
            param.personal = personal;
          } else {
            param.personal = null;
          }

          if (this.accountList.length == 0) {
            this.$message.info("请添加收款账户");
            return;
          }
          let flag = false;
          for (let obj of this.accountList) {
            if (obj.isDefault == "T") {
              flag = true;
              break;
            }
          }
          if (!flag) {
            this.$message.info("请设置默认账户");
            return;
          }
          param.merchantAccountList = this.accountList.concat(
            this.deleteAccountList
          );
          this.loading = true;
          this.$http.roomBksApi
            .saveMerchantAllInfo(param)
            .then(res => {
              if (res && res.result == 0) {
                this.$message.success(res.msg);
                this.back();
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$refs.accountForm.resetFields();
      this.visible = false;
      this.accountIndex = -1;
    },
    action(item, index, type) {
      this.accountIndex = index;
      if (type == "modify") {
        this.formAccount = Object.assign({}, item);
        this.visible = true;
      } else if (type == "del") {
        this.accountList.splice(index, 1);
        if (item.id) {
          item.isDelete = "T";
          this.deleteAccountList.push(item);
        }
      } else if (type == "default") {
        for (let i = 0; i < this.accountList.length; i++) {
          if (index == i) {
            this.accountList[i].isDefault = "T";
          } else {
            this.accountList[i].isDefault = "F";
          }
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  .gallery-item {
    height: 100px;
    width: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.operation {
  text-align: center;
  margin: 20px auto 5px;
  button {
    margin: 0 10px;
  }
}
.account-box {
}
.cell {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  .accout {
    width: 220px;
  }
  .opt {
    a {
      margin: 0 5px;
    }
  }
}
</style>
